export default __webpack_public_path__ + "static/media/9B.e252ce18.png";